import React, { useState, useEffect } from "react";
import {
	GetUsers,
	GetLastUser,
	SetLastUser,
} from "../../services/usersService";

export default function UserSelect({ classes, userChanged, Filter,label }) {
	const [users, setUsers] = useState([]);
	const [currentUser, setCurrentUser] = useState();

	useEffect(() => {
		async function loadUsers() {
			let u = await GetUsers(Filter);
			setUsers(u);
		}
		async function loadLastUser() {
			let user = await GetLastUser();
			setCurrentUser(user);
		}

		try {
			loadUsers();
			loadLastUser();
		} catch (err) {
			console.log(err);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		userChanged(currentUser);
	}, [currentUser]);

	const handleUserChange = (selected) => {
		setCurrentUser(selected);
		SetLastUser(selected);
		userChanged(selected);
	};

	return (
		<>
			<div className="columns">
				<div className="column">
					<span>
						<label htmlFor="" className="label">
						{label!==undefined && label!=="" ? label : "Select User"}	 
						</label>
					</span>
					<span>
						<select
							className="input"
							onChange={(e) => handleUserChange(e.target.value)}
							value={currentUser}
						>
							{users.map((u) => {
								return (
									<option key={u} value={u.trim()}>
										{u.trim()}
									</option>
								);
							})}
						</select>
					</span>
				</div>

			</div>
			
		</>
	);
}
